import React from 'react';
import { Feature } from '@/types/av-check';
import AlertType from './AlertType';

export interface AlertProps {
  type: AlertType
  noBorder?: boolean,
  headlineContent?: string,
  links?: React.ReactNode[]
}

const typeStyleClass = {
  [AlertType.SUCCESS]: 'alert-success',
  [AlertType.WARNING]: 'alert-warning',
  [AlertType.DANGER]: 'alert-danger',
  [AlertType.INFO]: 'alert-info',
};

export default class Alert extends React.Component<AlertProps> {
  static Type = AlertType;

  render() {
    const {
      type,
      noBorder,
      headlineContent,
      children,
      links = []
    } = this.props;

    let additionalStyleClasses: string[] = [typeStyleClass[type]];;

    if (noBorder) {
      additionalStyleClasses.push('no-border');
    }

    return (
      <div className={`alert ${additionalStyleClasses.join(' ')}`} role="alert">
        {headlineContent && <h3 dangerouslySetInnerHTML={{ __html: headlineContent }} />}
        {children}
        <ul className="related-links">
          {/* eslint-disable-next-line react/no-array-index-key */}
          {links.map((link, index) => <li key={index}>{link}</li>)}
        </ul>
      </div>
    );
  }
}
